import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-client';
import type { GearBoardProjectNode, GearBoardFilters } from '@/lib/types';

const GEAR_REQUESTS_API = '/api/v1/gear-requests';

function cleanFilters<T extends object>(filters: T): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(filters).filter(([, value]) => value !== '' && value !== undefined)
  );
}

export function useGearBoard(filters: GearBoardFilters = {}, enabled = true) {
  const clean = cleanFilters(filters);
  return useQuery({
    queryKey: queryKeys.gearRequests.board(clean),
    queryFn: async (): Promise<GearBoardProjectNode[]> => {
      const response = await apiClient.get<GearBoardProjectNode[]>(
        `${GEAR_REQUESTS_API}/board/`,
        { params: clean }
      );
      return response.data;
    },
    enabled,
  });
}

export type { GearBoardFilters };
